import Button from "../../../../../../common/components/atom/Button/Button";
import { useMicroNavigator } from "../../../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import { PermissionTooltip, useCapability } from "../../../../../rbac";

export default function AddNewBtnPresenter() {
  const {navigate} =useMicroNavigator()
  const canEdit = useCapability('planbt.edit')
  return (
    <PermissionTooltip allowed={canEdit}>
      <Button variant={"dark-parimary"} disabled={!canEdit} onClick={() => navigate('create')} iconRightType={"plus"}>Ajouter</Button>
    </PermissionTooltip>
  )
}
